import { Container, Row, Col, Form } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaClock } from 'react-icons/fa';
import { logo } from "../static";

const Contactos = () => {
    return (
        <>
            <Navbar />
            <main style={{ backgroundColor: "#fdfcf9" }}>
                
                {/* --- HEADER DA PÁGINA --- */}
                <section 
                    className="py-5 position-relative overflow-hidden" 
                    style={{ backgroundColor: "#2c2219", color: "#f4f1ea", minHeight: "35vh", display: "flex", alignItems: "center" }}
                >
                    <div 
                        className="position-absolute w-100 h-100"
                        style={{
                            top: 0, left: 0,
                            backgroundImage: `url(${logo})`,
                            backgroundSize: '40px 40px',
                            backgroundRepeat: 'repeat',
                            opacity: 0.03,
                            zIndex: 1
                        }}
                    />
                    <Container className="position-relative text-center" style={{ zIndex: 2 }}>
                        <h6 className="text-uppercase fw-bold mb-2" style={{ color: "#c5a47e", letterSpacing: "3px" }}>Canais de Atendimento</h6>
                        <h1 className="display-4 fw-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Contacte-nos</h1>
                        <p className="lead mx-auto opacity-75 mt-3" style={{ maxWidth: "700px" }}>
                            Estamos à disposição para oferecer o suporte jurídico que você ou sua empresa necessitam.
                        </p>
                    </Container>
                </section>

                <Container className="py-5 my-5">
                    <Row className="g-5">
                        
                        {/* COLUNA 1: INFORMAÇÕES DE CONTACTO */}
                        <Col lg={5} className="animate__animated animate__fadeInLeft">
                            <div className="pe-lg-5">
                                <h2 className="mb-4" style={{ color: "#2c2219", fontFamily: "'Playfair Display', serif" }}>Informações Directas</h2>
                                <p className="text-muted mb-5">Escolha o canal de sua preferência ou visite o nosso escritório em Talatona.</p>

                                <div className="d-flex mb-4">
                                    <div className="icon-box me-3">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Localização</h6>
                                        <p className="small text-muted">Avenida Via A2, Talatona, Luanda – Angola</p>
                                    </div>
                                </div>

                                <div className="d-flex mb-4">
                                    <div className="icon-box me-3">
                                        <FaPhone />
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Telefone</h6>
                                        <p className="small text-muted">+244 940 069 666</p>
                                    </div>
                                </div>

                                <div className="d-flex mb-4">
                                    <div className="icon-box me-3">
                                        <FaEnvelope />
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">E-mail</h6>
                                        <p className="small text-muted">info@paul-rodney.com</p>
                                    </div>
                                </div>

                                <div className="d-flex mb-5">
                                    <div className="icon-box me-3">
                                        <FaClock />
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Horário de Atendimento</h6>
                                        <p className="small text-muted">Segunda a Sexta: 08:00h – 18:00h</p>
                                    </div>
                                </div>

                                <a 
                                    href="https://wa.me/+244940069666" 
                                    className="btn btn-success rounded-0 px-4 py-3 w-100 d-flex align-items-center justify-content-center shadow-sm"
                                    style={{ backgroundColor: "#25D366", border: "none" }}
                                >
                                    <FaWhatsapp className="me-2 fs-4" /> Falar via WhatsApp
                                </a>
                            </div>
                        </Col>

                        {/* COLUNA 2: FORMULÁRIO DE AGENDAMENTO */}
                        <Col lg={7} className="animate__animated animate__fadeInRight">
                            <div className="bg-white p-5 shadow-sm border">
                                <h3 className="mb-4 fw-bold" style={{ color: "#2c2219", fontFamily: "'Playfair Display', serif" }}>Solicitar Consultoria</h3>
                                <Form>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="small fw-bold text-uppercase">Nome Completo</Form.Label>
                                                <Form.Control type="text" className="rounded-0 border-light-subtle p-3 bg-light" placeholder="Ex: João Silva" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="small fw-bold text-uppercase">E-mail</Form.Label>
                                                <Form.Control type="email" className="rounded-0 border-light-subtle p-3 bg-light" placeholder="exemplo@mail.com" />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="small fw-bold text-uppercase">Assunto / Área de Interesse</Form.Label>
                                        <Form.Select className="rounded-0 border-light-subtle p-3 bg-light">
                                            <option>Direito Civil</option>
                                            <option>Direito Comercial / Societário</option>
                                            <option>Direito do Trabalho</option>
                                            <option>Direito Imobiliário</option>
                                            <option>Outros</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group className="mb-4">
                                        <Form.Label className="small fw-bold text-uppercase">Sua Mensagem</Form.Label>
                                        <Form.Control as="textarea" rows={4} className="rounded-0 border-light-subtle p-3 bg-light" placeholder="Descreva brevemente a sua necessidade jurídica..." />
                                    </Form.Group>

                                    <button 
                                        type="submit" 
                                        className="btn btn-dark w-100 rounded-0 py-3 fw-bold text-uppercase"
                                        style={{ backgroundColor: "#2c2219", letterSpacing: "2px", transition: "0.3s" }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = "#c5a47e"}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = "#2c2219"}
                                    >
                                        Enviar Solicitação
                                    </button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />

            <style>{`
                .icon-box {
                    width: 45px;
                    height: 45px;
                    background-color: #f4f1ea;
                    color: #c5a47e;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0px;
                    font-size: 1.2rem;
                    transition: 0.3s;
                }
                .icon-box:hover {
                    background-color: #c5a47e;
                    color: #fff;
                }
                .form-control:focus, .form-select:focus {
                    box-shadow: none;
                    border-color: #c5a47e;
                    background-color: #fff;
                }
            `}</style>
        </>
    );
};

export default Contactos;